import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00cf31cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leadercheck-submitContainer" }
const _hoisted_2 = { class: "submit-container" }
const _hoisted_3 = { class: "fujian" }
const _hoisted_4 = { class: "button" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_canjiandanwei = _resolveComponent("canjiandanwei")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_leadermanger = _resolveComponent("leadermanger")!
  const _component_dutytime = _resolveComponent("dutytime")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.address,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.submitform.address) = $event)),
              rules: [{ required: true, message: '请填写问题地点' }],
              required: "",
              label: "问题地点",
              placeholder: "请填写问题地点"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_canjiandanwei, { onSelectCompany: _ctx.selectCompany }, null, 8, ["onSelectCompany"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.content,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.submitform.content) = $event)),
              rules: [{ required: true, message: '请填写督查内容' }],
              required: "",
              rows: "2",
              autosize: "",
              label: "督查内容",
              type: "textarea",
              maxlength: "400",
              placeholder: "请选择督查内容",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.problem,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.submitform.problem) = $event)),
              required: "",
              rules: [{ required: true, message: '请填写发现问题' }],
              label: "发现问题",
              placeholder: "请填写发现问题",
              maxlength: "400",
              "show-word-limit": "",
              rows: "2",
              autosize: "",
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.otherCreater,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.submitform.otherCreater) = $event)),
              label: "其他检查人员",
              placeholder: "请填写其他检查人员"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.entourage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.submitform.entourage) = $event)),
              label: "陪同人员",
              placeholder: "请填写陪同人员"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_field, {
              rules: [{ required: true, message: '请选择整改后照片' }],
              required: "",
              label: "附件"
            }, {
              input: _withCtx(() => [
                _createVNode(_component_van_uploader, {
                  modelValue: _ctx.uploader,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploader) = $event)),
                  "after-read": _ctx.afterRead,
                  multiple: _ctx.$isIOS()
                }, null, 8, ["modelValue", "after-read", "multiple"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_field, {
              modelValue: _ctx.submitform.resolution,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.submitform.resolution) = $event)),
              label: "处理意见",
              placeholder: "请填写处理意见",
              maxlength: "400",
              "show-word-limit": "",
              rows: "2",
              autosize: "",
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_leadermanger, { onSelectPerson: _ctx.selectPerson }, null, 8, ["onSelectPerson"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_dutytime, { onSelectLimit: _ctx.selectLimit }, null, 8, ["onSelectLimit"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_button, {
              disabled: _ctx.flag,
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}